import broadcastChannel from "@utils/broadcastChannel";

/**
 * Redux middleware that broadcasts whitelisted actions to other browser tabs.
 *
 * Usage — mark any action for broadcasting by attaching a meta flag:
 *
 *   dispatch({ ...setApplicationPermission(data), meta: { broadcast: true } })
 *
 * The middleware:
 *  1. Lets the action flow through the store normally (next(action) first).
 *  2. If action.meta.broadcast === true, posts { type, payload } over the
 *     shared BroadcastChannel.
 *  3. Does NOT include meta.broadcast in the posted message, so the receiving
 *     tab dispatches a plain action and the middleware there stays silent —
 *     preventing infinite cross-tab loops.
 */
const broadcastMiddleware = () => (next) => (action) => {
  const result = next(action);

  if (action?.meta?.broadcast && broadcastChannel) {
    broadcastChannel.postMessage({
      type: action.type,
      payload: action.payload,
    });
  }

  return result;
};

export default broadcastMiddleware;
